import React from 'react';
import {RETRIVE} from '../constants/constants';
import {postData} from '../constants/Utils';
import Swal from 'sweetalert2';
import logo from '../assets/logo.png'

class LinkForgotPass extends React.Component {
    constructor(props){
        super(props);
        this.state = {

        }
    }
    redirect(value){
        this.props.redirectTo(value);
    }
    retrivePassword(){
        var user = this.refs.username.value;
        var req = {
            'username':user
        }

        if(user!=="" || user!==null || user !==undefined){
            postData(RETRIVE,req).then(result =>{

                if(result.success){
                    Swal({
                        title: 'Completado',
                        text: 'El correo se envío correctamente',
                        type: 'success',
                        showConfirmButton: true
                      }).then((result) => { 
                        this.redirect('Login');
                      })
                }else{
                    Swal({
                        title: 'Error',
                        text: result.message,
                        type: 'warning',
                        showConfirmButton: true
                      }).then((result) => { 
                        
                      })
                }
            });
        }
    }
    render() {
        return (
            <div className="container">
            <div className="row justify-content-center signup-form">
                <div className=" col-12 col-md-9 col-lg-6 pt-20">
                    <div className="card signup-card">
                        <div className="card-head text-center px-15 p-md-15 bg-dark">
                            <div className="cp-logo pt-15">
                                <img alt="ClubPremier" width="80%" src={logo} />
                            </div>
                        </div>
                        <div className="card-body px-15 p-md-30 ">
                            <div className="row justify-content-center">
                                <div className="col-11 col-md-11 pt-11 text-center">
                                    <h2 className=" mb-20">Restablecer contraseña</h2>
                                    <p>Para restablecer su contraseña ingrese el correo electrónico 
                                        asociado a su cuenta, le enviaremos un correo con su nueva contraseña.  
                                        </p>
                                </div>
                                
                                
                                <div className="col-11 pt-30 p-10">
                                    <input className="form-control p-10" ref="username" name="username" placeholder="Correo electrónico" />
                                </div>
                                 
                                
                                <div className="col-8 pt-30 ">
                                <button className="col-12 btn btn-color-blue  p-10" onClick={this.retrivePassword.bind(this)} >Enviar correo</button>

                                    <div className="text-center pt-15">
                                        <a href="" onClick={this.redirect.bind(this,'Login')}>
                                            Cancelar</a></div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        );
    }
}
export default LinkForgotPass;



// WEBPACK FOOTER //
// ./src/components/LinkForgotPass.js